export function typeEvent() {

    $("input[id^='isFacebook_']").on('click', function (e) {

        let isFacebook = e.target.checked;
        let id = e.target.dataset.id;
        let $locationName = $('#location_name_' + id);
        let $locationUrl = $('#location_url_' + id);

        if(isFacebook) {
            $locationName.parent('div').hide();
            $locationName.val('');
            $locationUrl.parent('div').removeClass('d-none').show();
            $locationUrl.val('');

            return;
        }

        $locationName.parent('div').removeClass('d-none').show();
        $locationName.val('');
        $locationUrl.parent('div').hide();
        $locationUrl.val('');
    });
}

export function initFields(numberEvent) {
    let $duplicateDate = $('#duplicate-date_' + numberEvent);

    // Change ids
    $duplicateDate.find("input[id^='isFacebook_']").next().attr('for', 'isFacebook_' + numberEvent);
    $duplicateDate.find("input[id^='isFacebook_']").attr('id', 'isFacebook_' + numberEvent).attr('data-id', numberEvent);

    $duplicateDate.find("input[id^='location_url']").attr('id', 'location_url_' + numberEvent);
    $duplicateDate.find("input[id^='location_name']").attr('id', 'location_name_' + numberEvent);

    $duplicateDate.find("input[id^='event_dates_']").attr('id', 'event_dates_' + numberEvent);
    $duplicateDate.find("input[id^='event_dates_']").attr('data-id', numberEvent);

    $duplicateDate.find("input[id^='date_']").attr('id', 'date_' + numberEvent);
    $duplicateDate.find("input[id^='date_']").attr('data-id', numberEvent);

    $duplicateDate.find("input[id^='single-date_']").attr('data-id', numberEvent);
    $duplicateDate.find("input[id^='single-date_']").attr('id', 'single-date_' + numberEvent);

    $duplicateDate.find("input[id^='start_date_event_']").attr('id', 'start_date_event_' + numberEvent);
    $duplicateDate.find("input[id^='end_date_event_']").attr('id', 'end_date_event_' + numberEvent);

    $duplicateDate.find("select[id^='billing_profile_id").attr('id', 'billing_profile_id_' + numberEvent).val("");

    $duplicateDate.find("select[id^='hs_form_id").attr('id', 'hs_form_id_' + numberEvent).val("");

    let $locationName = $('#location_name_' + numberEvent);
    let $locationUrl = $('#location_url_' + numberEvent);
    let $isFacebook = $('#isFacebook_' + numberEvent);

    $locationName.val('').parent('div').removeClass('d-none').show();
    $locationUrl.val('').parent('div').hide();
    $isFacebook.removeAttr('checked');
}
